const Settings = () =>{
    return (
        <div>
            <h1>Settings Here</h1>
        </div>
    )
}

export default Settings;